export default __webpack_public_path__ + "static/media/lab6.799883ee.jpg";